import useLenis from "@/hooks/useLenis";
import { useEffect } from "react";
import Layout from "@/components/Layout";
import LandingReelHero from "@/components/LandingReelHero";
import FeatureFilmTeaserBand from "@/components/FeatureFilmTeaserBand";
import InnerSanctumBanner from "@/components/InnerSanctumBanner";

const API = process.env.REACT_APP_BACKEND_URL;

function trackVisitOnce() {
  try {
    const key = "resilience:visit:tracked";
    if (sessionStorage.getItem(key)) return;
    const params = new URLSearchParams(window.location.search);
    const ref = (params.get("ref") || document.referrer || "direct")
      .toString()
      .trim()
      .toLowerCase()
      .slice(0, 64);
    fetch(`${API}/api/track/visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ref, path: window.location.pathname }),
      keepalive: true,
    }).catch(() => {});
    sessionStorage.setItem(key, "1");
  } catch {
    /* noop */
  }
}

/**
 * Landing — Founder plain-ink 2026-02-15.
 * The reel and the Inner Sanctum. Nothing else.
 * The old landing tail (film strip · thirteen doors) moved to /games.
 */
export default function Landing() {
  useLenis();
  useEffect(() => {
    trackVisitOnce();
  }, []);
  return (
    <Layout>
      <div data-testid="public-landing" className="relative">
        <div className="games-shell">
          <LandingReelHero />
        </div>
        <FeatureFilmTeaserBand />
        <InnerSanctumBanner />
      </div>
    </Layout>
  );
}
